export default __webpack_public_path__ + "3c4f2e88157f84ab863c547b9d8a52e6.png";